import React from 'react';
import { View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

import { formatFreshFoodBoxLine, formatFreshFoodItems } from '../../../../common/utils/pickList/buildFreshFoodByStop';
import { Text } from '../../../components';
import { useThemedStyles } from '../../../hooks/useThemedStyles';
import { useTheme } from '../../../theme';

/**
 * The fresh food for one stop: ticked supplier boxes first, then the fresh pick list lines by brand.
 * `stop` comes from buildFreshFoodByStop.
 */
const FreshFoodLines = ({ stop }) => {
	const styles = useThemedStyles(createStyles);
	const { theme } = useTheme();

	return (
		<View>
			{
				stop.boxes.map(box => (
					<View key={`box_${box.id}`} style={styles.line}>
						<Ionicons name="cube-outline" size={15} color={theme.primary1} style={styles.icon} />
						<Text style={[styles.lineText, styles.boxText]}>{formatFreshFoodBoxLine(box)}</Text>
					</View>
				))
			}
			{
				stop.brands.map(brand => (
					<View key={`brand_${brand.id || 'other'}`} style={styles.line}>
						<Ionicons name="restaurant-outline" size={15} color={theme.text2} style={styles.icon} />
						<Text style={styles.lineText}>
							<Text style={styles.brandName}>{`${brand.name}: `}</Text>
							{formatFreshFoodItems(brand)}
						</Text>
					</View>
				))
			}
		</View>
	);
};

const createStyles = (theme) => ({
	line: {
		flexDirection: 'row',
		alignItems: 'flex-start',
		marginTop: 4,
	},
	icon: {
		marginTop: 1,
		marginRight: 6,
	},
	// Long product lists must wrap inside the card instead of pushing past the screen edge.
	lineText: {
		flex: 1,
		minWidth: 0,
		fontSize: 13,
		color: theme.text1,
	},
	boxText: {
		fontWeight: '600',
	},
	brandName: {
		fontWeight: '700',
		color: theme.text1,
	},
});

export default FreshFoodLines;
